import ProfileActions, { ProfileSelectors } from "Redux/ProfileRedux";
import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";
import React, { Component } from "react";
import styles, { SideProjectsContainer } from "./styles";

import { AuthenticationSelectors } from "Redux/AuthenticationRedux.js";
import Button from "Components/Button";
import ConfirmationModal from "Modals/ConfirmationModal";
import LoadingIcon from "Components/LoadingIcon";
import { MdClose } from "react-icons/md";
import { PageFailure } from "Themes/StyledComponents";
import ProfileDetails from "Components/ProfileDetails";
import SendMessageModal from "Modals/SendMessageModal";
import SideProject from "Components/SideProject";
import { compose } from "redux";
import { connect } from "react-redux";
import navRoutes from "Navigation/NavRoutes";
import styled from "styled-components";
import { withStyles } from "@material-ui/styles";

const StartProjectButton = styled(Button)`
  width: 200px;
`;

class ProfileScreen extends Component {
  state = {
    usersProfile: false,

    imageNotFound: false,
    sendMessageModalOpen: false,
    messageSent: false,
    showReviewModal: false,
    projectsRendered: false,
    projectToDelete: null,
    openDeleteModal: false,
    fetching: {
      profile: true,
      profject: true,
    },
    errors: {
      deleteProject: null,
      profile: false,
      projects: false,
    },
  };

  async componentDidMount() {
    const {
      match: { params },
      user,
      publicProfileRequest,
      getUserProjects,
    } = this.props;

    const publicProfileResolve = {
      onSuccess: () => {
        this.setState((prevState) => ({
          fetching: { ...prevState.fetching, profile: false },
        }));
      },
      onFailure: () =>
        this.setState((prevState) => ({
          errors: { ...prevState.errors, profile: true },
          fetching: { ...prevState.fetching, profile: false },
        })),
    };

    const projectsResolve = {
      onSuccess: () =>
        this.setState((prevState) => ({
          fetching: { ...prevState.fetching, project: false },
        })),
      onFailure: () =>
        this.setState((prevState) => ({
          errors: { ...prevState.errors, projects: true },
          fetching: { ...prevState.fetching, project: false },
        })),
    };

    if (user.id && user.id.toString() === params.id) {
      this.setState({ usersProfile: true });
    }

    await publicProfileRequest(params.id, publicProfileResolve);
    await getUserProjects(params.id, projectsResolve);
  }

  componentDidUpdate(prevProps) {
    const {
      match: { params },
    } = this.props;
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.props.publicProfileRequest(params.id);
    }
    if (params !== prevProps.match.params) {
      this.setState({
        imageNotFound: false,
      });
    }
  }

  _openModal = () => {
    this.setState({
      sendMessageModalOpen: true,
    });
  };

  _sendMessage = (values) => {
    const { id } = this.props.match.params;
    const { sendMessage, user, notificationChatRooms } = this.props;
    const message = {
      content: values.message,
      senderId: user.id,
      receiverId: parseInt(id),
      from: user.first_name,
    };

    let chatroom = 0;

    notificationChatRooms.forEach((element) => {
      if (element.senderId === user.id && element.receiverId === parseInt(id)) {
        chatroom = element.chatId;
      }
      if (element.receiverId === user.id && element.senderId === parseInt(id)) {
        chatroom = element.chatId;
      }
    });

    sendMessage(message, chatroom);

    this.setState({
      messageSent: true,
    });
  };

  _closeModal = () => {
    this.setState({
      sendMessageModalOpen: false,
      messageSent: false,
    });
  };

  _closeReviewModal = () => {
    this.setState({
      showReviewModal: false,
    });
  };

  renderProjects = () => {
    const {
      userProjects,
      history,
      match: { params },
      user,
      isAuthenticated,
    } = this.props;
    const { fetching } = this.state;

    if (fetching.project) {
      return <LoadingIcon />;
    }

    if (userProjects.length === 0) {
      if (isAuthenticated && params.id === user.id.toString()) {
        return (
          <StartProjectButton
            onClick={() => history.push(navRoutes.createProject)}
            style={{ width: "30%" }}
          >
            You haven't started any projects yet. Click here to get started
          </StartProjectButton>
        );
      }
      return <div>There are currently no projects</div>;
    }

    const renderedUserProjects =
      userProjects &&
      userProjects.map((project, key) => {
        return (
          <SideProject
            showTitle
            showRating
            key={key}
            icon={project.projectIcon}
            title={project.projectName}
            onClick={() => history.push(`${navRoutes.explore}/${project.id}`)}
            project={project}
          />
        );
      });

    return renderedUserProjects;
  };

  deleteProjectSuccess = () => {
    this.setState({
      openDeleteModal: false,
    });
  };

  deleteProjectFailure = (err) => {
    this.setState({
      errors: {
        deleteProject: err.message,
      },
    });
  };

  deleteProject = () => {
    const { projectToDelete } = this.state;
    const { deleteProject } = this.props;

    const resolve = {
      onSuccess: () => this.deleteProjectSuccess(),
      onFailure: (err) => this.deleteProjectFailure(err),
    };

    deleteProject(projectToDelete, resolve);
  };

  render() {
    const { user, publicProfile, classes, publicProfileLinks } = this.props;
    const {
      imageNotFound,
      openDeleteModal,
      errors,
      fetching,
      sendMessageModalOpen,
      usersProfile,
    } = this.state;

    if (fetching.profile) {
      return (
        <div style={{ textAlign: "center", marginTop: "25%" }}>
          <LoadingIcon />
        </div>
      );
    }

    if (errors.profile || errors.project) {
      return (
        <div className={classes.mainContainer}>
          <PageFailure>Oops...looks like there was an error</PageFailure>
        </div>
      );
    }

    const avatar = publicProfile.user.avatar;

    return (
      <div className={classes.mainContainer}>
        <SendMessageModal
          show={sendMessageModalOpen}
          onHide={() => this.setState({ sendMessageModalOpen: false })}
        />

        <ConfirmationModal
          show={openDeleteModal}
          onHide={() =>
            this.setState({
              openDeleteModal: false,
              errors: { deleteProject: null },
            })
          }
          title="Delete Project?"
          icon={<MdClose fontSize={30} color="red" />}
          buttonYes="danger"
          buttonNo="primary"
          onConfirm={() => this.deleteProject()}
          error={errors.deleteProject}
        />
        {publicProfile && (
          <>
            <ProfileDetails
              editableLinks={usersProfile}
              imageNotFound={imageNotFound}
              avatar={avatar}
              publicProfile={publicProfile}
              profileLinks={publicProfileLinks}
              onMessageClick={this._openModal}
              user={user}
              projectNumber={this.props.userProjects.length}
              onReview={() => this.setState({ showReviewModal: true })}
            />
            <SideProjectsContainer>
              {this.renderProjects()}
            </SideProjectsContainer>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: AuthenticationSelectors.getUserDetails(state),
    profile: ProfileSelectors.getProfile(state),
    publicProfile: ProfileSelectors.getPublicProfile(state),
    publicProfileLinks: ProfileSelectors.getProfileLinks(state),
    userProjects: ProjectSelectors.getUserProjects(state),
    projectFetching: ProjectSelectors.getFetching(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    profileRequest: (resolve) =>
      dispatch(ProfileActions.profileRequest(resolve)),
    publicProfileRequest: (data, resolve) =>
      dispatch(ProfileActions.publicProfileRequest(data, resolve)),
    getUserProjects: (data, resolve) =>
      dispatch(ProjectActions.getUserProjectsRequest(data, resolve)),
    deleteProject: (data, resolve) =>
      dispatch(ProjectActions.deleteProjectRequest(data, resolve)),
  };
};

const withRedux = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(
  withStyles(styles),
  withRedux
)(ProfileScreen);
